module.exports = __webpack_public_path__ + "img/service-card-2.15a71dc0.png";